module.exports = __webpack_public_path__ + "static/media/profileBanner.6524e1f2.jpeg";